export const makeCollectionName = (collectionId: string) =>
  `collections/${collectionId}`;

export const makeFavoritesCollectionId = (identityName: string) => {
  const identityId = identityName.split('/').pop()!;
  return `favorites-${identityId}`;
};

export const deriveFavoritesCollectionName = (identityName: string) =>
  makeCollectionName(makeFavoritesCollectionId(identityName));
